export default {
  path: 'tasks',
  name: 'Tasks',
};
